import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiClass } from '@data/class/api-class';
import { ProductServiceCatalogItem } from '../../interfaces/billing.interface';

/**
 * Catálogo Producto/Servicio para el dropdown "Clave" de los conceptos de facturación.
 * Backend: GET/POST/PUT catalogs/product-services (gateado por módulo `billing`).
 */
@Injectable({
  providedIn: 'root'
})
export class ProductServiceCatalogService extends ApiClass {

  constructor() {
    super();
    this.path = 'catalogs/product-services';
  }

  /**
   * Lista el catálogo (por default solo activos). Filtros opcionales por tipo y texto.
   */
  getProductServices(search?: string, type?: 'PRODUCTO' | 'SERVICIO'): Observable<ProductServiceCatalogItem[]> {
    const params: Record<string, string> = {};
    if (search) params['search'] = search;
    if (type) params['type'] = type;

    return this.getCollections(params).pipe(
      map((response) => (response.error ? [] : (response.data || [])))
    );
  }

  /**
   * Alta ad-hoc de una clave (Operaciones). Devuelve el ítem creado.
   */
  createProductService(dto: Partial<ProductServiceCatalogItem>): Observable<ProductServiceCatalogItem> {
    return this.postCollection(dto).pipe(
      map((response) => {
        if (response.error) {
          throw new Error(response.msg || 'No se pudo crear la clave del catálogo');
        }
        return response.data;
      })
    );
  }
}
